module.exports = __webpack_public_path__ + "static/img/2023年历-4.0031f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-4.jpg
// module id = D65S
// module chunks = 3